import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./MNewBadge.module.css";

interface MNewBadgeProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Small gradient "New" pill, absolutely positioned at the top-right of its
 * (relatively positioned) parent. Defaults to the translated "New" label.
 */
const MNewBadge: React.FC<MNewBadgeProps> = ({ className = "", children }) => {
  const { t } = useTranslation();
  return (
    <span className={`${styles.newBadge} ${className}`}>
      {children ?? t("common.new")}
    </span>
  );
};

export default MNewBadge;
